@let fieldPlaceholder =
    field.placeholder ||
    (field.required ? ("requiredPlaceholder" | t) : "");

@if (
    field.fieldType !== fieldType.CheckBox &&
    field.fieldType !== fieldType.Documents &&
    field.fieldType !== fieldType.OrganizationRiskMatrixEditor &&
    !hideLabel
) {
    <label for="form-title">
        {{ field.formattedName }}
    </label>
}

@if (!hideFillers && !field.hideFillers && field.fieldType === fieldType.CheckBox) {
    <!-- This is filler for checkboxes, so they align with other fieldtypes. -->
    <label for="form-title" class="d-block">&nbsp;</label>
}

@if (additionalData) {
    @if (additionalData[field.fieldName + "Loading"]) {
        <div class="loading">
            <i class="fas fa-circle-notch fa-spin"></i>
        </div>
    } @else {
        @if (field.fieldType === fieldType.CheckBox) {
            <cerrix-checkbox
                [label]="field.formattedName"
                [(value)]="row[field.fieldName]"
                [disabled]="field.isReadonly || !editEnabled"
            ></cerrix-checkbox>
        }
        @if (field.description) {
            @if (field.fieldType === fieldType.Label) {
                <label class="form-text normalWeight">
                    {{ field.description }}
                </label>
            } @else {
                <i
                    class="fas fa-info-circle ms-2"
                    [matTooltip]="field.description"
                    position="right"
                ></i>
            }
        }
        @switch (field.fieldType) {
            @case (fieldType.Text) {
                <cerrix-textfield
                    [dataUiid]="field.uiid"
                    [identifier]="field.fieldName"
                    [(ngModel)]="row[field.fieldName]"
                    [required]="field.required"
                    [placeholder]="fieldPlaceholder"
                    [disabled]="field.isReadonly || !editEnabled"
                >
                </cerrix-textfield>
            }
            @case (fieldType.Email) {
                <cerrix-textfield
                    [dataUiid]="field.uiid"
                    [identifier]="field.fieldName"
                    [(ngModel)]="row[field.fieldName]"
                    [required]="field.required"
                    [placeholder]="fieldPlaceholder"
                    [disabled]="field.isReadonly || !editEnabled"
                >
                </cerrix-textfield>
            }
            @case (fieldType.Phone) {
                <cerrix-textfield
                    [dataUiid]="field.uiid"
                    [identifier]="field.fieldName"
                    [(ngModel)]="row[field.fieldName]"
                    [required]="field.required"
                    [placeholder]="fieldPlaceholder"
                    [disabled]="field.isReadonly || !editEnabled"
                >
                </cerrix-textfield>
            }
            @case (fieldType.TextArea) {
                <cerrix-textarea
                    [dataUiid]="field.uiid"
                    [name]="field.fieldName"
                    [(ngModel)]="row[field.fieldName]"
                    [required]="field.required"
                    [placeholder]="fieldPlaceholder"
                    [disabled]="field.isReadonly || !editEnabled"
                    [rows]="5"
                >
                </cerrix-textarea>
            }
            @case (fieldType.Number) {
                <input
                    type="number"
                    [attr.data-uiid]="field.uiid"
                    class="form-control form-control-sm"
                    [name]="field.fieldName"
                    [(ngModel)]="row[field.fieldName]"
                    [required]="field.required"
                    [placeholder]="fieldPlaceholder"
                    [disabled]="field.isReadonly || !editEnabled"
                    [min]="field.minimumValue"
                    [max]="field.maximumValue"
                    ng-pattern="/^[0-9]*$/"
                />
            }
            @case (fieldType.Decimal) {
                <input
                    type="text"
                    [attr.data-uiid]="field.uiid"
                    class="form-control form-control-sm"
                    [name]="field.fieldName"
                    [(ngModel)]="row[field.fieldName]"
                    [required]="field.required"
                    [placeholder]="fieldPlaceholder"
                    [disabled]="field.isReadonly || !editEnabled"
                    ng-pattern="/^[-]?[0-9]+([.][0-9]{1,4})?$/"
                />
            }
            @case (fieldType.Date) {
                <date-input
                    [showTimePicker]="false"
                    [(value)]="row[field.fieldName]"
                    [attr.data-uiid]="field.uiid"
                    [minDate]="field.minimumValue"
                    [maxDate]="field.maximumValue"
                    [disabled]="field.isReadonly || !editEnabled"
                    [required]="field.required"
                >
                </date-input>
            }
            @case (fieldType.DateTime) {
                <date-input
                    [showTimePicker]="true"
                    [(value)]="row[field.fieldName]"
                    [attr.data-uiid]="field.uiid"
                    [minDate]="field.minimumValue"
                    [maxDate]="field.maximumValue"
                    [disabled]="field.isReadonly || !editEnabled"
                    [required]="field.required"
                >
                </date-input>
            }
            @case (fieldType.SingleSelect) {
                <ng-select
                    [name]="field.fieldName"
                    [attr.data-uiid]="field.uiid"
                    [multiple]="false"
                    [items]="additionalData[field.fieldName]"
                    [(ngModel)]="row[field.fieldName]"
                    (change)="updateSelect(field.fieldName, $event)"
                    bindLabel="Name"
                    bindValue="ID"
                    [closeOnSelect]="true"
                    [disabled]="field.isReadonly || !editEnabled"
                    [required]="field.required"
                    [placeholder]="fieldPlaceholder"
                    [clearable]="!field.required"
                    [appendTo]="field.appendTo"
                >
                </ng-select>
            }
            @case (fieldType.MultiSelect) {
                <ng-select
                    [name]="field.fieldName"
                    [attr.data-uiid]="field.uiid"
                    [multiple]="true"
                    [items]="additionalData[field.fieldName]"
                    [(ngModel)]="row[field.fieldName]"
                    (change)="updateSelect(field.fieldName, $event)"
                    bindLabel="Name"
                    bindValue="ID"
                    [closeOnSelect]="false"
                    [disabled]="field.isReadonly || !editEnabled"
                    [required]="field.required"
                    [placeholder]="fieldPlaceholder"
                    [clearable]="!field.required"
                    [appendTo]="field.appendTo"
                >
                </ng-select>
            }
            @case (fieldType.SingleTree) {
                <cerrix-select-tree
                    [attr.data-uiid]="field.uiid"
                    [multiselect]="false"
                    [tree]="additionalData[field.fieldName]"
                    [value]="row[field.fieldName]"
                    [required]="field.required"
                    [readonly]="field.isReadonly || !editEnabled"
                    [placeholder]="fieldPlaceholder"
                    (onChangeIds)="updateTreeSelection(field.fieldName, $event)"
                    (onChangeSingleId)="updateTreeSelection(field.fieldName, $event)"
                >
                </cerrix-select-tree>
            }
            @case (fieldType.MultiTree) {
                <cerrix-select-tree
                    [attr.data-uiid]="field.uiid"
                    [multiselect]="true"
                    [tree]="additionalData[field.fieldName]"
                    [value]="row[field.fieldName]"
                    [required]="field.required"
                    [readonly]="field.isReadonly || !editEnabled"
                    [placeholder]="fieldPlaceholder"
                    (onChangeIds)="updateTreeSelection(field.fieldName, $event)"
                    (onChangeSingleId)="updateTreeSelection(field.fieldName, $event)"
                >
                </cerrix-select-tree>
            }
            @case (fieldType.ColoredSelect) {
                <ng-select
                    [name]="field.fieldName"
                    [attr.data-uiid]="field.uiid"
                    [items]="additionalData[field.fieldName]"
                    [disabled]="field.isReadonly || !editEnabled"
                    [required]="field.required"
                    [placeholder]="fieldPlaceholder"
                    [(ngModel)]="row[field.fieldName]"
                    (change)="updateSelect(field.fieldName, $event)"
                    bindLabel="Name"
                    bindValue="ID"
                    [appendTo]="field.appendTo"
                >
                    <ng-template ng-label-tmp ng-option-tmp let-item="item">
                        <div
                            [style.background-color]="item.Color"
                            style="
                                min-width: 5px;
                                min-height: 16px;
                                float: left;
                                margin-right: 10px;
                            "
                        ></div>
                        {{ item.Name }}
                    </ng-template>
                </ng-select>
            }
            @case (fieldType.Documents) {
                <document-manager-old
                    [Documents]="row[field.fieldName]"
                    [attr.data-uiid]="field.uiid"
                    [Label]="field.formattedName"
                    [noMargin]="true"
                    [AllowAdd]="!field.isReadonly || editEnabled"
                    [AllowEdit]="!field.isReadonly || editEnabled"
                    [AllowDelete]="!field.isReadonly || editEnabled"
                ></document-manager-old>
            }
            @case (fieldType.StringArray) {
                <ng-select
                    [name]="field.fieldName"
                    [attr.data-uiid]="field.uiid"
                    [items]="additionalData[field.fieldName]"
                    [disabled]="field.isReadonly || !editEnabled"
                    [multiple]="true"
                    [(ngModel)]="row[field.fieldName]"
                    [required]="field.required"
                    [placeholder]="fieldPlaceholder"
                    (change)="updateSelect(field.fieldName, $event)"
                    [loading]="additionalData[field.fieldName + 'Loading']"
                    [addTag]="true"
                    [closeOnSelect]="false"
                    [appendTo]="field.appendTo"
                >
                </ng-select>
            }
            @case (fieldType.ColorPicker) {
                <cerrix-color-select
                    [dataUiid]="field.uiid"
                    [disabled]="field.isReadonly || !editEnabled"
                    [required]="field.required"
                    [(value)]="row[field.fieldName]"
                ></cerrix-color-select>
            }
            @case (fieldType.IconPicker) {
                <cerrix-icon-picker
                    [attr.data-uiid]="field.uiid"
                    [disabled]="field.isReadonly || !editEnabled"
                    [(value)]="row[field.fieldName]"
                ></cerrix-icon-picker>
            }
            @case (fieldType.GenericList) {
                <sub-list-manager
                    [attr.data-uiid]="field.uiid"
                    [disabled]="field.isReadonly || !editEnabled"
                    [(value)]="row[field.fieldName]"
                    [listConfig]="field.additionalConfig"
                ></sub-list-manager>
            }
            @case (fieldType.PreBox) {
                <pre class="prebox">{{ row[field.fieldName] }}</pre>
            }
            @case (fieldType.RenderBox) {
                <div class="renderbox" [innerHTML]="row[field.fieldName]"></div>
            }
            <!-- Custom Field types -->
            @case (fieldType.OrganizationRiskMatrixEditor) {
                <organization-riskmatrix-editor
                    [attr.data-uiid]="field.uiid"
                    [disabled]="field.isReadonly || !editEnabled"
                    [(value)]="row[field.fieldName]"
                    [row]="row"
                ></organization-riskmatrix-editor>
            }
            @case (fieldType.MultiSelectRiskMatrix) {
                <risk-appetite-selection
                    [attr.data-uiid]="field.uiid"
                    (valueChange)="updateSelect(field.fieldName, $event)"
                    [disabled]="field.isReadonly || !editEnabled"
                    [(value)]="row[field.fieldName]"
                >
                </risk-appetite-selection>
            }
            @case (fieldType.FrameworkAssessmentScores) {
                <framework-assessment-scores
                    [attr.data-uiid]="field.uiid"
                    [disabled]="field.isReadonly || !editEnabled"
                    [(value)]="row[field.fieldName]"
                    [row]="row"
                ></framework-assessment-scores>
            }
            @case (fieldType.CustomFields) {
                <custom-field-editor
                    [attr.data-uiid]="field.uiid"
                    [disabled]="field.isReadonly || !editEnabled"
                    [(value)]="row"
                    [field]="field"
                    [standingDataType]="standingDataType"
                ></custom-field-editor>
            }
            @case (fieldType.WYSIWYG) {
                <cerrix-editor-popup [(value)]="row[field.fieldName]"> </cerrix-editor-popup>
            }
        }
    }
}
